import React, { useEffect, useState }  from 'react';
import { Modal, Form } from 'react-bootstrap';
import { capitalize, basename, makesingular } from './utils';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


// update : should prefil the placeholders, actual record is sent as item
// addNew : should be empty, {} is sent as item; const attributes = Object.keys(item); 
const ModalItem = ({ item, itemFields, baseUrl, onClickAction, showModal, setShowModal }) => {

    const [newItem, setNewItem] = useState({});
    const name = capitalize(makesingular(basename(baseUrl)));

    useEffect(()=>{
        if (Object.keys(item).length > 0){
            setNewItem(item);
        }
    }, [item]);

    return(
        <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
            <Modal.Title>{`${Object.keys(item).length > 0 ? 'Update ' : 'Add New '}`}{name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form>
                {
                    itemFields.map((field, index) =>
                        <Form.Group className="mb-3" controlId="formName" key={`form-group-id-${index}`}>
                        <Form.Label>{capitalize(field)}</Form.Label>
                        {
                            field === 'deadline' ? 
                            <div>
                            <DatePicker 
                            selected={(newItem[field] !== null && 
                                    newItem[field] !== undefined && 
                                    Object.keys(newItem).length > 0 ) ? 
                                        new Date(newItem[field]) : 
                                        new Date()} 
                            onChange={(date) => {
                                var newObj = { ...newItem };
                                const formattedDate = date.toISOString().slice(0, 10);
                                newObj[field] = formattedDate;
                                setNewItem(newObj); }}
                            className='form-control' />
                            </div> : 
                            <Form.Control
                            type="text" autoComplete="off"
                            placeholder={ Object.keys(newItem).length > 0 ? item[field] : '' }
                            value={Object.keys(newItem).length > 0 ? newItem[field] : '' }
                            onChange={(e) => {
                                var newObj = { ...newItem };
                                newObj[field] = e.target.value;
                                setNewItem(newObj);
                                }}/>
                        }
                        </Form.Group>
                    )
                }
            </Form>
        </Modal.Body>
        <Modal.Footer>

        <div className='btn-container'>
        <button className='btn-custom-flex blue' onClick={() => {
            setNewItem(item);
            setShowModal(false);
        }}>Cancel</button>
        <button className='btn-custom-flex green' onClick={() => {
            onClickAction(newItem);
            setNewItem({});
            setShowModal(false);
        }}>Save</button>

        </div>

        </Modal.Footer>
        </Modal> 
    )
}


export default ModalItem;
